import type { AllEffect, ForkEffect } from 'redux-saga/effects';
import { all, fork } from 'redux-saga/effects';
import { adminSaga } from './admin/sagas';
import { authenticationSaga } from './authentication/sagas';
import { customerSaga } from './customer/sagas';
import { regionsSaga } from './regions/sagas';

export function* rootSaga<T>(): Generator<AllEffect<ForkEffect<void>>, void, T> {
  yield all([fork(adminSaga), fork(authenticationSaga), fork(customerSaga), fork(regionsSaga)]);
}
